import React from 'react';
import classnames from 'classnames';
import { IconSize, Props as IconProps } from '@wix/da-ds/pkg/Icons/IconWrap';
import s from './ActionBarIcon.scss';

export interface Props {
  icon?: React.ComponentType<IconProps>;
  iconRef?: React.RefObject<HTMLElement | null>;
  isActive?: boolean;
  children?: (iconProps: IconProps) => React.ReactNode;
}

const ActionBarIcon: React.FC<Props> = ({ icon: Icon, iconRef, isActive, children }) => {
  const iconProps = {
    className: classnames(isActive && s['active']),
    customSizable: false,
    disableDefaultColors: true,
    containerRef: iconRef,
    iconSize: IconSize.MEDIUM,
  };

  if (children) {
    return <>{children(iconProps)}</>;
  }

  if (Icon) {
    return <Icon {...iconProps} />;
  }

  return null;
};
ActionBarIcon.displayName = 'ActionBarIcon';

export default ActionBarIcon;
